/* Refillia: mega menu da computer, foglio dal basso da telefono */
(function () {
  function avvia() {
    var nav = document.querySelector('[data-rf-mega]');
    if (!nav || nav.dataset.rfPronto) return;
    nav.dataset.rfPronto = '1';
    var mega = nav.querySelector('[data-rf-mega-pannello]');
    var testata = document.getElementById('header-component') || nav.closest('header') || document.body;
    var bottoni = nav.querySelectorAll('[data-rf-apri]');
    // il pannello va nel body: la testata ha un effetto vetro che sposterebbe un elemento fisso
    if (mega) document.body.appendChild(mega);
    var aperto = null, timer = null;
    // i pannelli arrivano da un template: si costruiscono al primo passaggio sul menu,
    // o in un momento libero sui computer, così la pagina parte più leggera
    function prepara() {
      var t = mega && mega.querySelector('template[data-rf-mega-dopo]');
      if (t) mega.replaceChild(t.content, t);
    }
    if (mega) {
      nav.addEventListener('pointerenter', prepara, { once: true });
      nav.addEventListener('focusin', prepara, { once: true });
      if (window.matchMedia('(hover: hover) and (min-width: 750px)').matches) {
        var libero = function () { (window.requestIdleCallback || setTimeout)(prepara, { timeout: 3000 }); };
        if (document.readyState === 'complete') libero(); else window.addEventListener('load', libero, { once: true });
      }
    }

    function misura() {
      // il bordo basso della riga con il menu, non del contenitore della testata
      var riga = nav.closest('.header__row') || nav.closest('.header__columns') || testata;
      var r = riga.getBoundingClientRect();
      document.documentElement.style.setProperty('--rf-mega-top', Math.max(0, Math.round(r.bottom)) + 'px');
    }
    function apri(k) {
      clearTimeout(timer);
      prepara();
      misura();
      mega.hidden = false;
      mega.querySelectorAll('[data-rf-mp]').forEach(function (p) { p.hidden = p.dataset.rfMp !== k; });
      bottoni.forEach(function (b) { b.setAttribute('aria-expanded', b.dataset.rfApri === k); });
      aperto = k;
      /* con il pannello aperto la testata non ha angoli tondi: niente spicchi di fondo pagina fra i due */
      document.documentElement.classList.add('rf-mega-aperto');
    }
    function chiudi() {
      mega.hidden = true;
      bottoni.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      aperto = null;
      document.documentElement.classList.remove('rf-mega-aperto');
    }
    var hover = window.matchMedia('(hover: hover)').matches;
    bottoni.forEach(function (b) {
      if (hover) b.addEventListener('mouseenter', function () { apri(b.dataset.rfApri); });
      b.addEventListener('click', function () { if (aperto === b.dataset.rfApri) chiudi(); else apri(b.dataset.rfApri); });
    });
    if (hover) {
      nav.addEventListener('mouseleave', function () { timer = setTimeout(chiudi, 220); });
      mega.addEventListener('mouseenter', function () { clearTimeout(timer); });
      mega.addEventListener('mouseleave', function () { timer = setTimeout(chiudi, 220); });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && aperto) { var b = nav.querySelector('[data-rf-apri="' + aperto + '"]'); chiudi(); if (b) b.focus(); } });
    document.addEventListener('click', function (e) { if (aperto && !nav.contains(e.target) && !mega.contains(e.target)) chiudi(); });
    window.addEventListener('scroll', function () { if (aperto) misura(); }, { passive: true });
    window.addEventListener('resize', function () { if (aperto) misura(); });

    // telefono: il foglio si sposta nel body, così nessun contenitore della testata lo nasconde
    var foglio = document.querySelector('[data-rf-foglio]');
    var velo = document.querySelector('[data-rf-foglio-velo]');
    if (!foglio || !velo) return;
    document.body.appendChild(velo);
    document.body.appendChild(foglio);
    var prima = null;
    function apriFoglio() {
      prima = document.activeElement;
      velo.hidden = false; foglio.hidden = false;
      void foglio.offsetWidth;
      velo.classList.add('on'); foglio.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
      var x = foglio.querySelector('[data-rf-foglio-chiudi]');
      if (x) x.focus({ preventScroll: true });
    }
    function chiudiFoglio() {
      if (typeof pulisci === 'function') pulisci();
      velo.classList.remove('on'); foglio.classList.remove('on');
      document.documentElement.style.overflow = '';
      setTimeout(function () { velo.hidden = true; foglio.hidden = true; }, 380);
      if (prima && prima.focus) prima.focus({ preventScroll: true });
    }
    // il pulsante del menu di Horizon apre il nostro foglio
    function pulisci() {
      document.querySelectorAll('header-drawer details').forEach(function (d) {
        d.classList.remove('menu-open'); d.removeAttribute('open');
        var sm = d.querySelector('summary'); if (sm) sm.setAttribute('aria-expanded', 'false');
      });
    }
    ['pointerdown', 'click'].forEach(function (tipo) {
      window.addEventListener(tipo, function (e) {
        var s = e.target.closest && e.target.closest('header-drawer summary');
        if (!s || window.matchMedia('(min-width: 750px)').matches) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (tipo === 'click') { pulisci(); apriFoglio(); }
      }, true);
    });
    foglio.querySelector('[data-rf-foglio-chiudi]').addEventListener('click', chiudiFoglio);
    velo.addEventListener('click', chiudiFoglio);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !foglio.hidden) chiudiFoglio(); });
    var cerca = foglio.querySelector('[data-rf-foglio-cerca]');
    if (cerca) cerca.addEventListener('click', function () {
      chiudiFoglio();
      var b = document.querySelector('#header-component search-button button');
      if (b) setTimeout(function () { b.click(); }, 60);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
